import React, { useEffect, useState } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { Badge, Box, Button, Drawer, Flex, Group, Image, Modal, Pagination, Text } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import NoData from '../../../../component/ui/NoData'
import { IconPlus } from '@tabler/icons-react'
import LoadingData from '../../../../component/ui/LoadingData'
import { useDebouncedCallback } from '@mantine/hooks'
import { deleteDataBanner, getAllBannerList } from '../../../../services/banner'
import TableBanners from '../../../../component/pages/Banner/TableBanners'
import FormFilterBanners from '../../../../component/pages/Banner/FormFilterBanners'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import FormBanner from '../../../../component/pages/Banner/FormBanner'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  'sort': '-created_at',
}


const labelTable = [
  {
    label: 'Banner Name',
    width: 200
  },
  {
    label: 'Image',
    width: 100
  },
  {
    label: 'Banner Action',
    width: 150
  },
  {
    label: 'Position',
    width: 50
  },
  {
    label: 'Priority',
    width: 50
  },
  {
    label: 'Status',
    width: 50
  },
  {
    label: 'Action',
    width: 50
  },
]

const Banners = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [loading, setLoading] = useState(true)
  const [bannerList, setBannerList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [openModalFilter, setOpenModalFilter] = useState(false)

  // form
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const [openModalImage, setModalImage] = useState(false)
  const [imageSelected, setImageSelected] = useState('')

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'Banners',
      route: null
    },
  ]


  const handleGetBannerList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllBannerList(params)
      if (response.success) {
        const { data, meta } = response

        const countData = meta.pagination.total

        const remap = data.map(banner => {
          const { attributes } = banner
          return {
            id: attributes.id,
            actionType: attributes.action_type,
            name: attributes.name,
            position: attributes.position,
            priority: attributes.priority,
            status: attributes.status,
            image: attributes.url,
            actionId: Array.isArray(attributes.action_id) ? attributes.action_id : attributes.action_id ? [attributes.action_id] : [],
            countryBanners: Array.isArray(attributes.country_banners)
              ? attributes.country_banners
              : typeof attributes.country_banners === "string"
                ? attributes.country_banners.split(',').filter(Boolean)
                : [],
            customUrl: attributes.custom_url,
            description: attributes.description,
            forOneProduct: attributes.for_one_product,
            membershipId: Array.isArray(attributes.membership_id) ? attributes.membership_id : attributes.membership_id ? [String(attributes.membership_id)] : [],
            membershipName: attributes.membership_name,
            userOrigin: Array.isArray(attributes.user_origin) ? attributes.user_origin : attributes.user_origin ? [attributes.user_origin] : [],
          }
        })
        setBannerList(remap)
        setTotalData(countData)
      }
      else {
        setBannerList([])
        setTotalData(0)
      }
    } catch (error) {
      console.log('error', error)
      setBannerList([])
      setTotalData(0)
    } finally {
      setLoading(false)
    }
  }, 500)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])


  useEffect(() => {
    handleGetBannerList()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setOpenModalForm(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('banner', val.id, val.name, deleteDataBanner, handleGetBannerList)
    },
    showImage: (val) => {
      setImageSelected(val.image)
      setModalImage(true)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

  const onCloseModalForm = () => {
    setDetailData(null)
    setOpenModalForm(false)
  }

  const onCloseModalImage = () => {
    setImageSelected('')
    setModalImage(false)
  }

  const mappingFilterBanner = (parameter) => {
    if (parameter['filter[status][is]'] || parameter['filter[position][is]'] || parameter['filter[country_banners][is]'] || parameter['filter[user_origin][is]']) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[status][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Status : {parameter['filter[status][is]']}</Badge> : ''}
            {parameter['filter[position][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Position : {parameter['filter[position][is]']}</Badge> : ''}
            {parameter['filter[country_banners][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Country Catalog Product : {parameter['filter[country_banners][is]']}</Badge> : ''}
            {parameter['filter[user_origin][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Country Signup User : {parameter['filter[user_origin][is]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Banner List</Text>
            <Group gap='sm' align='center'>
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)} >Add New Banner</Button>
            </Group>
          </Flex>
        </Box>
        {mappingFilterBanner(params)}
        <Box my={30}>
          <Group mb={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{totalData} Banners </Text>
          </Group>
          {loading ? <LoadingData /> : bannerList.length > 0 ? <TableBanners label={labelTable} data={bannerList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' value={params['page[num]']} onChange={handleChangePage} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>

      <Drawer position='right' title='Filter Banner' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormFilterBanners paramsBanners={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
      </Drawer>

      <Drawer position='right' size={'xl'} title={<Text fw='Bold'>{detailData !== null ? 'Update' : 'Add'} Banner</Text>} opened={openModalForm} onClose={onCloseModalForm} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormBanner dataBanner={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetBannerList} />
      </Drawer>

      <Modal opened={openModalImage} onClose={onCloseModalImage} size={'xl'}>
        <Image
          radius="md"
          src={imageSelected}
        />
      </Modal>
    </AuthLayout>
  )
}

export default Banners